import { AssignmentMetricsSummary } from '@/pages/OperationsInsights/types/AssignmentMetricsResponse';

export type AssignmentSummaryComponentItem = {
    value: number | string;
    changeText: string;
    hasChange?: boolean;
    isPositive?: boolean;
    isGoodChange?: boolean;
}

export type AssignmentSummariesComponentData = {
    openAssignmentTotalSM?: AssignmentSummaryComponentItem;
    openAssignmentAtRiskSM?: AssignmentSummaryComponentItem;
    openAssignmentBreachedSM?: AssignmentSummaryComponentItem;
    totalCompletedCount?: AssignmentSummaryComponentItem;
    completedAssignmentRateSM?: AssignmentSummaryComponentItem;
};

export const tfAssignmentSummariesData = (assignmentMetricsSummary: AssignmentMetricsSummary): AssignmentSummariesComponentData => {
    const assignmentSummaries = {
        openAssignmentTotalSM: {
            value: 0,
            changeText: '',
            hasChange: false,
            isPositive: false,
            isGoodChange: false
        },
        openAssignmentAtRiskSM: {
            value: 0,
            changeText: '',
            hasChange: false,
            isPositive: false,
            isGoodChange: false
        },
        openAssignmentBreachedSM: {
            value: 0,
            changeText: '',
            hasChange: false,
            isPositive: false,
            isGoodChange: false
        },
        totalCompletedCount: {
            value: 0,
            changeText: '',
            hasChange: false,
            isPositive: false,
            isGoodChange: false
        },
        completedAssignmentRateSM: {
            value: '',
            changeText: '',
            hasChange: false,
            isPositive: false,
            isGoodChange: false
        }
    };

    // assignmentSummaries.openAssignmentTotalSM.value = assignmentMetricsSummary.totalOpenCountEoP;
    assignmentSummaries.openAssignmentTotalSM.value = assignmentMetricsSummary.totalOpenWithinSLAEoP;

    assignmentSummaries.openAssignmentAtRiskSM.value = assignmentMetricsSummary.totalOpenAtRiskEoP;
    assignmentSummaries.openAssignmentBreachedSM.value = assignmentMetricsSummary.totalOpenBreachedEoP;
    assignmentSummaries.totalCompletedCount.value = assignmentMetricsSummary.totalCompleted;
    assignmentSummaries.completedAssignmentRateSM.value = `${assignmentMetricsSummary.completionRatePerHour ?? 0}/hr`;

    return assignmentSummaries;
};